import React, { FC, useState, useEffect, useContext } from 'react'
import { notify } from 'react-notify-toast'
import firebase from 'firebase/app'
import moment from 'moment'
import _ from 'lodash'
import { isMobile } from 'react-device-detect'
import { useLocation } from 'react-router-dom';

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../NavigationBar/NavigationBar'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericMainCard from '../../GenericComponents/GenericMainCard'
import GenericSwitch from '../../GenericComponents/GenericSwitch'
import GenericButton from '../../GenericComponents/GenericButton'
import GenericLogo from '../../GenericComponents/GenericLogo'
import GenericInput from '../../GenericComponents/GenericInput'
import GenericRange from '../../GenericComponents/GenericRange'
import GenericIcon from '../../GenericComponents/GenericIcon'
import GenericRow from '../../GenericComponents/GenericRow'
import GenericMobileTopNavigation from '../../GenericComponents/GenericMobileTopNavigation'
import Navigation from '../Challenges/components/Navigation/Navigation'

import AppContext from '../../context/appContext'
import changeLocation from '../../utils/changeLocalization'

import FitmatkaLogo from '../../assets/REDESIGN_Assets/ChatBox/logo-image.webp'
import FitmatkaImage from '../../assets/REDESIGN_Assets/LiveScreen/fitmatka-image.webp'

import { ChatBoxBox, ChatBoxColumn } from '../ChatBox/style/ChatBoxStyle'

interface LiveInterface { }

const Live: FC<LiveInterface> = ({ }) => {
  const appContext = useContext(AppContext)
  const location = useLocation()

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`${appContext.appState.theme == 'light' ? 'light' : 'standard'
        }`}
    >
      {location.state && location.state.challengeMode ?
        <Navigation /> :

        <NavigationBar
          isPlayerView={false}
          backButtonAction={() => changeLocation(location.state && location.state.challengeMode ? "/wyzwania" : '/trening')}
        />}
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          handleClick={() => location.state && location.state.challengeMode ? changeLocation({ pathname: '/twoj-profil', state: { challengeMode: true } }) : changeLocation('/twoj-profil')}
          dietCartClick={null}
        />
      )}

      <ChatBoxBox>
        {!isMobile && (
          <ChatBoxColumn>
            <GenericIcon
              position={'absolute'}
              top={'1%'}
              left={'25%'}
              src={FitmatkaImage}
              width={'35vw'}
              height={'99vh'}
            ></GenericIcon>
            <GenericIcon
              position={'absolute'}
              top={'68%'}
              left={'33%'}
              backgroundSize={'contain'}
              src={FitmatkaLogo}
              width={'25%'}
              height={'30%'}
              zIndex={'2'}
            ></GenericIcon>
          </ChatBoxColumn>
        )}
        {isMobile && (
          <GenericIcon
            zIndex={'0'}
            position={'absolute'}
            top={'-18vh'}
            left={'0'}
            src={FitmatkaImage}
            width={'100vw'}
            height={'100vh'}
          ></GenericIcon>
        )}
        <ChatBoxColumn>
          <GenericMainCard
            opacity={'0.9'}
            flexDir={'column'}
            width={isMobile ? '95%' : '60%'}
            className="standard"
            padding={'3%'}
          >
            <GenericTextSpan fSize={'1.6rem'} margin={'10vh 0'} width={'60%'}>
              Aktualnie nie ma prowadzonej transmisji live
            </GenericTextSpan>
            <GenericButton
              className="standard"
              width={'60%'}
              justify={'center'}
              onClick={() => changeLocation(location.state && location.state.challengeMode ? "/wyzwania" : '/trening')}
            >
              OK
            </GenericButton>
          </GenericMainCard>
        </ChatBoxColumn>
      </ChatBoxBox>
    </GenericBackgroundLayer>
  )
}

export default Live
